import React, { useEffect, useState } from "react";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  Button,
  InputLabel,
} from "@material-ui/core";
import { DropdownDateRangePicker } from "./SelectDateRange";
import {
  convertTo24Hour,
  formatDateToString,
  getEndDate,
  getStartDate,
} from "../Utility/utilis";
import { format, parseISO } from "date-fns";

import GTLabel from "components/GTLabel";
import Container from "containers/anx1/SharedModule/DropdownTreeContainer";
import { useDispatch, useSelector } from "react-redux";

import SchedularTable from "./SchedularTable";
import "../style.css";
import {
  createSchedule,
  getEntityList,
  getGstinByEntity,
  getGstinList,
  getSchedularList,
  setSchedulerTableData,
} from "./action";
import { errorToastMessage } from "utils/errorToast";
import CustomSelect from "../Utility/CustomSelect";
import { COMMON_MSGS } from "Constant/Messages";
import { ToastContainer } from "react-toastify";

export default function Schedular({ open, onClose, handleTabChange }) {
  const dispatch = useDispatch();
  const activeTab = useSelector((state) => state.emailConfigReducer.activeTab);
  const [frequency, setFrequency] = useState("");
  const [isOpen, setIsOpen] = useState(false);
  const [hour, setHour] = useState("");
  const [ampm, setAmpm] = useState("");
  const [selectedTime, setSelectedTime] = useState("");
  const [minute, setMinute] = useState("");

  // Entity and GSTIN related local states
  const [entityList, setEntityList] = useState([]);
  const [selectedEntity, setSelectedEntity] = useState("");
  const [gstinList, setGstinList] = useState([]);
  const [selectedGstins, setSelectedGstins] = useState([]);
  const [isGstinDropdownDisabled, setIsGstinDropdownDisabled] = useState(true);

  const hours = Array.from({ length: 12 }, (_, i) =>
    String(i + 1).padStart(2, "0")
  );
  const minutes = Array.from({ length: 60 }, (_, i) =>
    String(i).padStart(2, "0")
  );

  const handleTimeSet = () => {
    if (hour && minute && ampm) {
      const time = `${hour}:${minute} ${ampm}`;
      setSelectedTime(time);
      setIsOpen(false);
    }
  };

  const [dateRange, setDateRange] = useState([
    {
      startDate: null,
      endDate: null,
      key: "selection",
    },
  ]);

  // Fetch entity list on component mount
  useEffect(() => {
    const fetchEntityList = async () => {
      try {
        await dispatch(getEntityList());
      } catch (error) {
        console.log("Error fetching entity list:", error);
        errorToastMessage("Error while fetching entity list");
      }
    };
    fetchEntityList();
  }, []);

  // Entity list selector from Redux (but we'll keep local state as requested)
  const { entityList: reduxEntityList } = useSelector(
    (state) => state.noticeReducer
  );

  // Update local entity list when Redux state changes
  useEffect(() => {
    if (reduxEntityList && reduxEntityList.length > 0) {
      setEntityList(reduxEntityList);
    }
  }, [reduxEntityList]);

  const formatDateRecoTab = (date) => {
    if (!date) return "";
    if (typeof date === "string") {
      try {
        return format(parseISO(date), "dd MMM");
      } catch {
        console.error("Invalid ISO date string:", date);
        return "";
      }
    }
    if (date instanceof Date && !isNaN(date.getTime())) {
      return format(date, "dd MMM");
    }
    console.error("Invalid date value:", date);
    return "";
  };

  const resetAllStates = () => {
    setFrequency("");
    setSelectedTime("");
    setHour("");
    setAmpm("");
    setMinute("");
    setIsOpen(false);
    dispatch(setSchedulerTableData([]));
    // Clear entity/GSTIN states
    setSelectedEntity("");
    setGstinList([]);
    setSelectedGstins([]);
    setIsGstinDropdownDisabled(true);
    // Clear selection and selectedYear local states
    setSelection({});
    setSelectedYear(null);
  };

  const [profile, setProfile] = useState([]);
  const [selection, setSelection] = useState({});
  const [selectedYear, setSelectedYear] = useState(null);

  // Cleanup function to clear selections on unmount
  useEffect(() => {
    return () => {
      resetAllStates();
    };
  }, []);

  const handleSchedule = async () => {
    try {
      if (
        !selectedGstins ||
        !frequency ||
        !selectedTime ||
        !dateRange[0]?.startDate ||
        !dateRange[0]?.endDate
      ) {
        return errorToastMessage(COMMON_MSGS.ENTER_MANDATORY_FIELDS);
      }
      const time24Hour = convertTo24Hour(selectedTime);
      const formattedStartDate = formatDateToString(dateRange[0]?.startDate);
      const formattedEndDate = formatDateToString(dateRange[0]?.endDate);

      const scheduleData = {
        gstin: selectedGstins,
        freqCode: frequency,
        runTimeLocal: time24Hour,
        startDate: formattedStartDate,
        endDate: formattedEndDate,
        timezone: "Asia/Kolkata",
      };
      console.log("Schedule Data:", scheduleData);
      const created = await dispatch(createSchedule(scheduleData));
      if (created) {
        console.log("Schedule created successfully");
        await dispatch(getSchedularList(null,false));
      }
    } catch (error) {
      console.log("error in handleSchedule:", error);
    }
  };

  const handleCancel = () => {
    resetAllStates();
    onClose();
  };

  const handleEntityChange = async (value) => {
    console.log("Entity selected:", value);
    setSelectedEntity(value || "");

    // Clear GSTIN selection and list when entity changes
    setSelectedGstins([]);
    setGstinList([]);
    setIsGstinDropdownDisabled(true);

    if (value) {
      try {
        // Call the API to get GSTINs for selected entity
        const gstinData = await dispatch(getGstinByEntity(value));

        if (gstinData && gstinData.length > 0) {
          // Format GSTIN data for the dropdown
          const formattedGstins = gstinData.map((item) => ({
            label: item.gstin,
            value: item.gstin,
            ...item,
          }));
          setGstinList(formattedGstins);
          setIsGstinDropdownDisabled(false);
        } else {
          setGstinList([]);
          setIsGstinDropdownDisabled(true);
          errorToastMessage("No GSTINs found for selected entity");
        }
      } catch (error) {
        console.log("Error fetching GSTINs for entity:", error);
        setGstinList([]);
        setIsGstinDropdownDisabled(true);
        errorToastMessage("Error while fetching GSTINs for selected entity");
      }
    }
  };

  const handleGstin = (currentNode, selectedNodes) => {
    let gstArr = [];
    if (selectedNodes[0]?.label === "All GSTIN") {
      // Select all available GSTINs
      gstArr = gstinList.map((item) => item.value || item.gstin);
    } else {
      gstArr = selectedNodes.map((item) => {
        return item.gstin || item.GSTIN || item.value || item.label;
      });
    }
    setSelectedGstins(gstArr);
    console.log("Selected GSTINs:", gstArr);
  };

  // Build profile data for GSTIN dropdown based on local state
  useEffect(() => {
    let newProfile = gstinList.map((v) => ({
      ...v,
      label: v.gstin || v.label,
      value: v.gstin || v.value,
      className: v.scheduled ? "gstin-scheduled" : "",
    }));

    const AllProfile = [
      {
        label: "All GSTIN",
        value: "All GSTIN",
        checked: false,
        tagClassName: "special",
        children: newProfile,
      },
    ];

    setProfile(AllProfile);
  }, [gstinList, selectedEntity]);
  
  return (
    <>
    <ToastContainer
              position="top-right"
              autoClose={5000}
              hideProgressBar={false}
              newestOnTop={false}
              closeOnClick
              rtl={false}
              pauseOnVisibilityChange
              draggable
              pauseOnHover
              style={{ zIndex: 99999 }}
            />
    <Dialog
      open={open}
      onClose={onClose}
      fullWidth
      maxWidth="md"
      style={{ zIndex: 9999 }}
    >
      
            {/* <div className="sweet-loading">
              <RingLoader size={100} color={"#123abc"} loading={loaderStatus} />
            </div> */}
      <div className="Schedular">
        <DialogTitle
          style={{
            textAlign: "center",
            paddingTop: 10,
            paddingBottom: 0,
            margin: 0,
            color: "#4f2d7f",
          }}
        >
          Scheduler
        </DialogTitle>
        <DialogContent>
          <div className="Schedular-fields">
            <div className="Schedular-dropdown-Section">
              <div className="Schedular-select-entity-dropdown">
                <InputLabel
                  id="demo-simple-select-autowidth-label"
                  className="text_label"
                  style={{
                    fontFamily: "GT-Walsheim-medium",
                    fontSize: "12px",
                    color: "black",
                    marginBottom: "10px",
                  }}
                >
                  Select Entity *
                </InputLabel>

                <div
                  style={{
                    width: "200px",
                  }}
                >
                  <CustomSelect
                    values={entityList.map((entity) => ({
                      label: entity.label,
                      value: entity.value,
                      checked: selectedEntity === entity.value,
                    }))}
                    optionHeading="Select"
                    selectedValue={selectedEntity || ""}
                    handleChange={(e) => handleEntityChange(e.target.value)}
                  />
                </div>
              </div>
              <div className="schedular-gstin-dropdown">
                <GTLabel
                  title={"Select GSTIN *"}
                  style={{
                    fontFamily: "GT-Walsheim-medium",
                    fontSize: "12px",
                  }}
                />
                <Container
                  id="gstin-select"
                  data={profile}
                  onChange={handleGstin}
                  mode="multiSelect"
                  isDisabled={isGstinDropdownDisabled}
                  searchable={true}
                />
              </div>
              <div className="Schedular-date-range-dropdown">
                <InputLabel
                  id="demo-simple-select-autowidth-label"
                  className="text_label"
                  style={{
                    fontFamily: "GT-Walsheim-medium",
                    fontSize: "12.5px",
                    color: "black",
                    top: "10px",
                  }}
                >
                  Select Date Range *
                </InputLabel>
                <DropdownDateRangePicker
                  initialStartDate={
                    selectedYear ? getStartDate(selectedYear) : null
                  }
                  initialEndDate={
                    selectedYear ? getEndDate(selectedYear) : null
                  }
                  minDate={selectedYear ? getStartDate(selectedYear) : null}
                  maxDate={selectedYear ? getEndDate(selectedYear) : null}
                  setDateRange={setDateRange}
                  dateRange={dateRange}
                  width={"210px"}
                  formatDateRecoTab={formatDateRecoTab}
                  tab="Reco"
                  selection={selection}
                />
              </div>
              <div className="Schedular-frequency-dropdown">
                <h6>Frequency *</h6>
                <select
                  value={frequency}
                  onChange={(e) => setFrequency(e.target.value)}
                >
                  <option value="">Select Frequency</option>
                  <option value="1">Weekly</option>
                  <option value="2">Daily</option>
                  <option value="3">Monthly</option>
                  <option value="4">Yearly</option>
                </select>
              </div>
            </div>

            <div className="Schedular-actionButtons">
              <div className="Schedular-time-dropdown">
                <h6>Select Time *</h6>
                <div
                  onClick={() => setIsOpen(!isOpen)}
                  style={{
                    backgroundColor: "#ffffff",
                    height: "39px",
                    padding: "8px",
                    borderRadius: "4px",
                    border: "1px solid #ccc",
                    width: "180px",
                  }}
                >
                  {selectedTime || "Select Time"}
                </div>

                {isOpen && (
                  <div
                    style={{
                      position: "absolute",
                      left: 0,
                      width: 200,
                      backgroundColor: "#fff",
                      border: "1px solid #ccc",
                      borderRadius: "4px",
                      padding: "10px",
                      zIndex: 1000,
                    }}
                  >
                    <div
                      style={{
                        display: "flex",
                        gap: "6px",
                        marginBottom: "8px",
                      }}
                    >
                      <select
                        style={{ width: 60 }}
                        value={hour}
                        onChange={(e) => setHour(e.target.value)}
                      >
                        <option value="">HH</option>
                        {hours.map((h) => (
                          <option key={h} value={h}>
                            {h}
                          </option>
                        ))}
                      </select>

                      <select
                        style={{ width: 60 }}
                        value={minute}
                        onChange={(e) => setMinute(e.target.value)}
                      >
                        <option value="">MM</option>
                        {minutes.map((m) => (
                          <option key={m} value={m}>
                            {m}
                          </option>
                        ))}
                      </select>

                      <select
                        style={{ width: 60 }}
                        value={ampm}
                        onChange={(e) => setAmpm(e.target.value)}
                      >
                        <option value="">AM/PM</option>
                        {["AM", "PM"].map((ap) => (
                          <option key={ap} value={ap}>
                            {ap}
                          </option>
                        ))}
                      </select>
                    </div>
                    <button onClick={handleTimeSet}>Set</button>
                  </div>
                )}
              </div>
              <div className="Schedule-action-button">
                <Button
                  id="schedule-button"
                  variant="contained"
                  color="primary"
                  onClick={handleSchedule}
                >
                  Schedule
                </Button>

                <Button
                  id="cancel-button"
                  variant="contained"
                  color="secondary"
                  onClick={handleCancel}
                >
                  Cancel
                </Button>
              </div>
            </div>
            {/* <div
              style={{
                display: "flex",
                height: "3em",
                boxShadow: "0px 2px 3px 0px #8080805e",
                paddingRight: "5px",
              }}
            >
              <TableHeader
                handleTabChange={handleTabChange}
                columns={headerColumns}
                activeTab={activeTab}
              />
            </div>*/}
          </div>

          {activeTab === 1 && <SchedularTable />}
          {/* {activeTab === 2 && <HistoryTable />} */}
        </DialogContent>
      </div>
    </Dialog>
    </>
  );
}
